import MDBox from "components/MDBox";
import MDAlert from "components/MDAlert";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const ResponseAlert = (props) => (
  <MDBox {...(props.sx && props.sx)}>
    <MDAlert color={props.color} dismissible>
      <MDTypography variant="body2" fontWeight="medium" color="white">
        {props.content}
      </MDTypography>
    </MDAlert>
  </MDBox>
);

const SuccessResponse=({data,onChange,success})=>{
  setTimeout(()=>{
    onChange(null)
  },2000)
  const color = success===true?"success":"error"
  const content=success===true?data.data.message:data.response.data.message
  return(
    <MDBox>
      <MDAlert color={color} onClick={onChange}>
        {content}
      </MDAlert>
    </MDBox>
  )
}

const DialogAlert = (props) => {
  return (
    <Dialog open={props.open}>
      <DialogTitle>{props.title}</DialogTitle>
      {props.content && (
        <DialogContent>
          <DialogContentText>{props.content}</DialogContentText>
        </DialogContent>
      )}

      <DialogActions style={{ display: "flex", justifyContent: "center" }}>
        <MDButton
          color="info"
          style={{ width: "4rem" }}
          onClick={() => {
            props.onOk();
          }}
        >
          Ok
        </MDButton>
        <MDButton variant="outlined" color="info" style={{ width: "4rem" }} onClick={props.onClose}>
          Close
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

export { ResponseAlert,SuccessResponse, DialogAlert };
